var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import styled from 'styled-components';
import { Color, Size, FontWeight } from '../const/';
import Question from '../question/question';
function PageHeader(props) {
    var title = props.title, actions = props.actions, helpText = props.helpText, helpLink = props.helpLink;
    return (React.createElement("div", null,
        React.createElement(Wrapper, null,
            React.createElement(TitleWrapper, null,
                React.createElement(Title, null, title),
                helpText && React.createElement(Question, __assign({ text: helpText, link: helpLink }, props))),
            actions && React.createElement("div", null, actions))));
}
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  align-items: center;\n  border-bottom: 1px solid ", ";\n  box-sizing: border-box;\n  display: flex;\n  height: 66px;\n  justify-content: space-between;\n  padding: 12px 28px;\n"], ["\n  align-items: center;\n  border-bottom: 1px solid ", ";\n  box-sizing: border-box;\n  display: flex;\n  height: 66px;\n  justify-content: space-between;\n  padding: 12px 28px;\n"])), Color.LIGHT_GRAY_2);
var Title = styled.h2(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: ", ";\n  font-size: ", "px;\n  font-weight: ", ";\n  margin-right: 8px;\n"], ["\n  color: ", ";\n  font-size: ", "px;\n  font-weight: ", ";\n  margin-right: 8px;\n"])), Color.VERY_DARK_GRAY, Size.FONT.XXLARGE, FontWeight.BOLD);
var TitleWrapper = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  align-items: center;\n  display: flex;\n"], ["\n  align-items: center;\n  display: flex;\n"])));
export default PageHeader;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=page-header.js.map